<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu danh sách quản lý thu chi đã gửi lên CSDLQG</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Đơn vị tạo:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption" ref="unitTree"></unit-tree>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="QĐ phê duyệt PAXL:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input v-model="searchForm.filterText"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="5"></b-col>
                            <b-col md="6">
                                <b-form-group label=""
                                              label-for="project"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="data/handling-decisions-accounting-list"
                            gridName="Danh sách thu chi"
                            ref="assetExploitationDecision">
                        <!--<template v-slot:actions v-if="hasDeletePermission">
                            <b-button size="md" @click.stop="removeSelected" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>
                        </template>-->
                        <template v-slot:cell(decisionDate)="row">
                            {{ row.item.decisionDate | formatDate }}
                        </template>
                        <template v-slot:cell(obtainedDate)="row">
                            {{ row.item.obtainedDate | formatDate }}
                        </template>
                        <template v-slot:cell(valueEstimated)="row">
                            {{ row.item.valueEstimated | currency }}
                        </template>
                        <template v-slot:cell(valueObtained)="row">
                            {{ row.item.valueObtained | currency }}
                        </template>
                        <template v-slot:cell(valueRemaining)="row">
                            {{ row.item.valueRemaining | currency }}
                        </template>
                        <template v-slot:cell(handlingCost)="row">
                            {{ row.item.handlingCost | currency }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewNationalPublicAssetHandlingAccounting'])" size="sm" :to="{ path: `./${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <b-button size="sm"
                                          v-if="hasDeletePermission"
                                          @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                    Xoá
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    export default {
        name: 'NationalPublicAssetConfiscateDecisions',
        mixins: [mixins],
        data() {
            return {
                listAssetSource: [],
                searchForm: {
                    unitId: this.getUnitTreeIdCache(1),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    keyword: null
                },
                gridOptions: {
                    fields: [
                        { key: 'planNames', label: 'QĐ phê duyệt PAXL', sortable: true, sortDirection: 'asc' },
                        { key: 'valueEstimated', label: 'Tổng số tiền phải thu', sortable: true, sortDirection: 'asc', tdClass: 'text-right' },
                        { key: 'valueObtained', label: 'Tổng số tiền đã thu', sortable: true, sortDirection: 'asc', tdClass: 'text-right' },
                        { key: 'valueRemaining', label: 'Tổng số tiền còn phải thu', sortable: true, sortDirection: 'asc', tdClass: 'text-right' },
                        { key: 'handlingCost', label: 'Tổng chi phí', sortable: true, sortDirection: 'asc', tdClass:'text-right'},
                        { key: 'unitName', label: 'Đơn vị tạo', sortable: true, sortDirection: 'asc' },
                    ],
                    sortBy: 'planNames',
                },
                isShowBtnDelete: true
            }
        },
        computed: {
            hasDeletePermission() {
                return this.authorize(['ManageNationalPublicAssetHandlingAccounting']);
            }
        },
        created() {
            //this.searchForm.unitId = this.$store.state.identity.unitId || 1;
        },
        watch: {
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.assetExploitationDecision.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.assetExploitationDecision.refresh();
            },
            loadAssetSource() {
                if (this.searchForm.decisionType) {

                }
            },
            removeSelected() {
                var vm = this;
                var selectedRows = this.$refs.assetExploitationDecision.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các quản lý thu chi này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/handling-decisions-accountings?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các quản lý thu chi thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn quản lý thu chi cần xóa');
                }
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa quản lý thu chi này?')) {
                    this.$services.delete(`data/handling-decisions-accountings/${item.id}`).done((data) => {
                        if (data) {
                            vm.$toastr.s('Xóa quản lý thu chi thành công');
                        }
                        else {
                            vm.$toastr.e('Xóa quản lý thu chi thành công, do có dữ liệu phụ thuộc !');
                        }
                        vm.search();
                    });
                }
            },
        }
    }
</script>
<style scoped>
    .w30 {
        width: 30px;
    }
    .bTableThStyle {
        text-align: right;
    }
</style>
